<template>
  <base-wrapper :loading="loading">
    <div class="space-y-4">
      <div class="flex justify-end gap-2">
        <office-select-search
          :shadow="false"
          :request-params="{ 'filter[office_category_id]': 3 }"
          v-model="filter.office"
          @change="onFilter"
        />
        <period-select v-model="filter.period_id" @change="onFilter" />
      </div>
      <alert
        v-if="!filter.office.attributes?.office_id || !filter.period_id"
        type="warning"
        message="Stockist belum dipilih"
      />
      <template v-else>
        <datatable
          :columns="tableColumns"
          :total="balanceTransactions.meta.page.total"
          :perPage="balanceTransactions.meta.page.perPage"
          :currentPage="balanceTransactions.meta.page.currentPage"
          @pagechanged="onPageChanged"
        >
          <template #add-thead="{ classes }">
            <tr>
              <td :class="[classes.th, 'text-right']">Keluar</td>
              <td :class="[classes.th, 'text-right']">Masuk</td>
              <td :class="[classes.th, 'text-right']">Saldo</td>
              <td :class="[classes.th, 'text-right']">Keluar</td>
              <td :class="[classes.th, 'text-right']">Masuk</td>
              <td :class="[classes.th, 'text-right']">Saldo</td>
              <td :class="[classes.th, 'text-right']">Keluar</td>
              <td :class="[classes.th, 'text-right']">Masuk</td>
              <td :class="[classes.th, 'text-right']">Saldo</td>
              <td :class="[classes.th, 'text-right']">Keluar</td>
              <td :class="[classes.th, 'text-right']">Masuk</td>
              <td :class="[classes.th, 'text-right']">Saldo</td>
              <td :class="[classes.th, 'text-right']">Keluar</td>
              <td :class="[classes.th, 'text-right']">Masuk</td>
              <td :class="[classes.th, 'text-right']">Saldo</td>
            </tr>
          </template>
          <template #tbody="{ classes }">
            <tr
              v-for="balanceTransaction in balanceTransactions.data"
              :key="balanceTransaction.attributes.id"
              :class="[classes.tr, 'bg-white']"
            >
              <td :class="classes.td">
                {{
                  balanceTransaction.attributes.createdAt
                    | formatDate('DD/MM/YYYY')
                }}
              </td>
              <td :class="classes.td">
                <a
                  v-if="
                    balanceTransaction.attributes.order_code ||
                    balanceTransaction.attributes.payment_code
                  "
                  href="#"
                  class="cursor-pointer hover:underline"
                  @click.prevent="onOpenDetail(balanceTransaction)"
                  >({{
                    balanceTransaction.attributes.order_code ||
                    balanceTransaction.attributes.payment_code
                  }})</a
                >
                {{ balanceTransaction.attributes.description }}
              </td>
              <td :class="[classes.td, 'text-right']">
                <p
                  v-if="
                    balanceTransaction.attributes.balance_type ===
                      'sc_restock_balance' &&
                    balanceTransaction.attributes.order_price
                  "
                >
                  -{{ balanceTransaction.attributes.order_price | toCurrency }}
                </p>
              </td>
              <td :class="[classes.td, 'text-right']">
                <p
                  v-if="
                    balanceTransaction.attributes.balance_type ===
                      'sc_restock_balance' &&
                    balanceTransaction.attributes.payment_amount
                  "
                >
                  +{{
                    balanceTransaction.attributes.payment_amount | toCurrency
                  }}
                </p>
              </td>
              <td :class="[classes.td, 'text-right']">
                <p
                  class="font-bold text-gray-900"
                  v-if="
                    balanceTransaction.attributes.balance_type ===
                    'sc_restock_balance'
                  "
                >
                  {{ balanceTransaction.attributes.balance | toCurrency }}
                </p>
              </td>
              <td :class="[classes.td, 'text-right']">
                <p
                  v-if="
                    balanceTransaction.attributes.balance_type ===
                      'sc_overpayment_balance' &&
                    balanceTransaction.attributes.order_price
                  "
                >
                  -{{ balanceTransaction.attributes.order_price | toCurrency }}
                </p>
              </td>
              <td :class="[classes.td, 'text-right']">
                <p
                  v-if="
                    balanceTransaction.attributes.balance_type ===
                      'sc_overpayment_balance' &&
                    balanceTransaction.attributes.payment_amount
                  "
                >
                  +{{
                    balanceTransaction.attributes.payment_amount | toCurrency
                  }}
                </p>
              </td>
              <td :class="[classes.td, 'text-right']">
                <p
                  class="font-bold text-gray-900"
                  v-if="
                    balanceTransaction.attributes.balance_type ===
                    'sc_overpayment_balance'
                  "
                >
                  {{ balanceTransaction.attributes.balance | toCurrency }}
                </p>
              </td>
              <td :class="[classes.td, 'text-right']">
                <p
                  v-if="
                    balanceTransaction.attributes.balance_type ===
                      'sc_debt_balance' &&
                    balanceTransaction.attributes.order_price
                  "
                >
                  -{{ balanceTransaction.attributes.order_price | toCurrency }}
                </p>
              </td>
              <td :class="[classes.td, 'text-right']">
                <p
                  v-if="
                    balanceTransaction.attributes.balance_type ===
                      'sc_debt_balance' &&
                    balanceTransaction.attributes.payment_amount
                  "
                >
                  +{{
                    balanceTransaction.attributes.payment_amount | toCurrency
                  }}
                </p>
              </td>
              <td :class="[classes.td, 'text-right']">
                <p
                  class="font-bold text-gray-900"
                  v-if="
                    balanceTransaction.attributes.balance_type ===
                    'sc_debt_balance'
                  "
                >
                  {{ balanceTransaction.attributes.balance | toCurrency }}
                </p>
              </td>
              <td :class="[classes.td, 'text-right']">
                <p
                  v-if="
                    balanceTransaction.attributes.balance_type ===
                      'sc_deposit_balance' &&
                    balanceTransaction.attributes.order_price
                  "
                >
                  -{{ balanceTransaction.attributes.order_price | toCurrency }}
                </p>
              </td>
              <td :class="[classes.td, 'text-right']">
                <p
                  v-if="
                    balanceTransaction.attributes.balance_type ===
                      'sc_deposit_balance' &&
                    balanceTransaction.attributes.payment_amount
                  "
                >
                  +{{
                    balanceTransaction.attributes.payment_amount | toCurrency
                  }}
                </p>
              </td>
              <td :class="[classes.td, 'text-right']">
                <p
                  class="font-bold text-gray-900"
                  v-if="
                    balanceTransaction.attributes.balance_type ===
                    'sc_deposit_balance'
                  "
                >
                  {{ balanceTransaction.attributes.balance | toCurrency }}
                </p>
              </td>
              <td :class="[classes.td, 'text-right']">
                <p
                  v-if="
                    balanceTransaction.attributes.balance_type ===
                      'multiplied_sc_deposit_balance' &&
                    balanceTransaction.attributes.order_price
                  "
                >
                  -{{ balanceTransaction.attributes.order_price | toCurrency }}
                </p>
              </td>
              <td :class="[classes.td, 'text-right']">
                <p
                  v-if="
                    balanceTransaction.attributes.balance_type ===
                      'multiplied_sc_deposit_balance' &&
                    balanceTransaction.attributes.payment_amount
                  "
                >
                  +{{
                    balanceTransaction.attributes.payment_amount | toCurrency
                  }}
                </p>
              </td>
              <td :class="[classes.td, 'text-right']">
                <p
                  class="font-bold text-gray-900"
                  v-if="
                    balanceTransaction.attributes.balance_type ===
                    'multiplied_sc_deposit_balance'
                  "
                >
                  {{ balanceTransaction.attributes.balance | toCurrency }}
                </p>
              </td>
            </tr>
            <tr :class="[classes.tr, 'bg-white']">
              <td></td>
              <td :class="classes.td">Total</td>
              <td :class="[classes.td, 'text-right']">
                <p v-if="summary?.sc_restock_balance?.total_order_price">
                  {{
                    summary.sc_restock_balance.total_order_price | toCurrency
                  }}
                </p>
              </td>
              <td :class="[classes.td, 'text-right']">
                <p v-if="summary?.sc_restock_balance?.total_payment_amount">
                  {{
                    summary.sc_restock_balance.total_payment_amount | toCurrency
                  }}
                </p>
              </td>
              <td :class="[classes.td, 'text-right']">
                <p
                  class="font-bold text-gray-900"
                  v-if="summary?.sc_restock_balance?.balance"
                >
                  {{ summary.sc_restock_balance.balance | toCurrency }}
                </p>
              </td>
              <td :class="[classes.td, 'text-right']">
                <p v-if="summary?.sc_overpayment_balance?.total_order_price">
                  {{
                    summary.sc_overpayment_balance.total_order_price
                      | toCurrency
                  }}
                </p>
              </td>
              <td :class="[classes.td, 'text-right']">
                <p v-if="summary?.sc_overpayment_balance?.total_payment_amount">
                  {{
                    summary.sc_overpayment_balance.total_payment_amount
                      | toCurrency
                  }}
                </p>
              </td>
              <td :class="[classes.td, 'text-right']">
                <p
                  class="font-bold text-gray-900"
                  v-if="summary?.sc_overpayment_balance?.balance"
                >
                  {{ summary.sc_overpayment_balance.balance | toCurrency }}
                </p>
              </td>
              <td :class="[classes.td, 'text-right']">
                <p v-if="summary?.sc_debt_balance?.total_order_price">
                  {{ summary.sc_debt_balance.total_order_price | toCurrency }}
                </p>
              </td>
              <td :class="[classes.td, 'text-right']">
                <p v-if="summary?.sc_debt_balance?.total_payment_amount">
                  {{
                    summary.sc_debt_balance.total_payment_amount | toCurrency
                  }}
                </p>
              </td>
              <td :class="[classes.td, 'text-right']">
                <p
                  class="font-bold text-gray-900"
                  v-if="summary?.sc_debt_balance?.balance"
                >
                  {{ summary.sc_debt_balance.balance | toCurrency }}
                </p>
              </td>
              <td :class="[classes.td, 'text-right']">
                <p v-if="summary?.sc_deposit_balance?.total_order_price">
                  {{
                    summary.sc_deposit_balance.total_order_price | toCurrency
                  }}
                </p>
              </td>
              <td :class="[classes.td, 'text-right']">
                <p v-if="summary?.sc_deposit_balance?.total_payment_amount">
                  {{
                    summary.sc_deposit_balance.total_payment_amount | toCurrency
                  }}
                </p>
              </td>
              <td :class="[classes.td, 'text-right']">
                <p
                  class="font-bold text-gray-900"
                  v-if="summary?.sc_deposit_balance?.balance"
                >
                  {{ summary.sc_deposit_balance.balance | toCurrency }}
                </p>
              </td>
              <td :class="[classes.td, 'text-right']">
                <p
                  v-if="
                    summary?.multiplied_sc_deposit_balance?.total_order_price
                  "
                >
                  {{
                    summary.multiplied_sc_deposit_balance.total_order_price
                      | toCurrency
                  }}
                </p>
              </td>
              <td :class="[classes.td, 'text-right']">
                <p
                  v-if="
                    summary?.multiplied_sc_deposit_balance?.total_payment_amount
                  "
                >
                  {{
                    summary.multiplied_sc_deposit_balance.total_payment_amount
                      | toCurrency
                  }}
                </p>
              </td>
              <td :class="[classes.td, 'text-right']">
                <p
                  class="font-bold text-gray-900"
                  v-if="summary?.multiplied_sc_deposit_balance?.balance"
                >
                  {{
                    summary.multiplied_sc_deposit_balance.balance | toCurrency
                  }}
                </p>
              </td>
            </tr>
          </template>
        </datatable>
      </template>

      <BaseModal :showing="false">
        <BaseCard title="Detail Transaksi" :with-style="false"> </BaseCard>
      </BaseModal>
    </div>
  </base-wrapper>
</template>

<script>
import { requestMixin } from '@/mixins/request/request';
import Alert from '@/components/base/AlertMessage.vue';
import OfficeSelectSearch from '@/components/office/office-select-search.vue';
import PeriodSelect from '@/components/period/period-select.vue';
import BaseModal from '../../../../../components/base/BaseModal.vue';

export default {
  mixins: [requestMixin],
  components: {
    Alert,
    OfficeSelectSearch,
    PeriodSelect,
    BaseModal,
  },
  data() {
    return {
      currentPeriod: {
        data: {
          attributes: {},
        },
      },
      filter: {
        office: {
          attributes: {
            office_id: null,
          },
        },
        period_id: null,
      },
      loadingCurentPeriod: false,
      loadingBalanceTransaction: false,
      loadingSummary: false,
      balanceTransactions: {
        data: [],
        meta: {
          page: {
            total: 0,
          },
        },
      },
      summary: null,
    };
  },
  computed: {
    loading() {
      return (
        this.loadingCurentPeriod ||
        this.loadingBalanceTransaction ||
        this.loadingSummary
      );
    },
    tableColumns() {
      return [
        {
          id: 'createdAt',
          name: 'Tanggal',
          rowspan: 2,
        },
        {
          id: 'description',
          name: 'Keterangan',
          rowspan: 2,
        },
        {
          id: 'restock',
          name: 'Restock',
          colspan: 3,
          theadClass: 'text-center',
        },
        {
          id: 'overpayment',
          name: 'Sisa Bayar',
          colspan: 3,
          theadClass: 'text-center',
        },
        {
          id: 'debt',
          name: 'Kurang Bayar',
          colspan: 3,
          theadClass: 'text-center',
        },
        {
          id: 'deposit',
          name: 'Deposit',
          colspan: 3,
          theadClass: 'text-center',
        },
        {
          id: 'multiplied_deposit',
          name: 'Nilai Deposit',
          colspan: 3,
          theadClass: 'text-center',
        },
      ];
    },
  },
  methods: {
    async loadCurrentPeriod() {
      this.loadingCurentPeriod = true;

      const [res, err] = await this.request(
        '/api/v1/periods/-actions/get-current-period'
      );

      if (!err) {
        this.currentPeriod = res;

        this.filter.period_id = res.data.id;
      }

      this.loadingCurentPeriod = false;
    },
    async loadBalanceTransactions(params) {
      this.loadingBalanceTransaction = true;

      const [res, err] = await this.request(
        `/api/v1/offices/${this.filter.office.attributes?.office_id}/office-balance-transactions`,
        {
          params: {
            'filter[period_uuid]': this.filter.period_id,
            sort: '-id',
            'page[size]': 10,
            ...params,
          },
        }
      );

      if (!err) {
        this.balanceTransactions = res;
      }

      this.loadingBalanceTransaction = false;
    },
    async loadSummary() {
      this.loadingSummary = true;

      const [res, err] = await this.request(
        `/api/v1/office-balance-summaries`,
        {
          params: {
            'filter[office_uuid]': this.filter.office.attributes?.office_id,
            'filter[period_uuid]': this.filter.period_id,
          },
        }
      );

      if (!err) {
        if (res.data.length) {
          this.summary = Object.fromEntries(
            res.data.map((summary) => [
              summary.attributes.balance_type,
              {
                total_order_price: summary.attributes.total_order_price,
                total_payment_amount: summary.attributes.total_payment_amount,
                balance: summary.attributes.balance,
              },
            ])
          );
        } else {
          this.summary = null;
        }
      }

      this.loadingSummary = false;
    },
    onFilter() {
      this.loadBalanceTransactions();
      this.loadSummary();
    },
    onPageChanged(page) {
      this.loadBalanceTransactions({
        'page[number]': page,
      });
    },
    onOpenDetail() {},
  },
  async created() {
    await this.loadCurrentPeriod();
  },
};
</script>
